/**
 * @generated SignedSource<<ada1ff23de1a01d7e9bf12b3971470c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoreActionsCancelFurtherResponsesMutation$variables = {
  id: string;
};
export type MoreActionsCancelFurtherResponsesMutation$data = {
  readonly cancelFurtherResponses: {
    readonly feedback: {
      readonly id: string;
      readonly requestCount: number;
      readonly requests: ReadonlyArray<{
        readonly feedbackRecord: {
          readonly id: string;
        } | null;
        readonly id: string;
      }>;
      readonly responseCount: number;
    };
  } | null;
};
export type MoreActionsCancelFurtherResponsesMutation = {
  response: MoreActionsCancelFurtherResponsesMutation$data;
  variables: MoreActionsCancelFurtherResponsesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CancelFurtherResponses",
    "kind": "LinkedField",
    "name": "cancelFurtherResponses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeedbackNode",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackRequestNode",
            "kind": "LinkedField",
            "name": "requests",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackRecordNode",
                "kind": "LinkedField",
                "name": "feedbackRecord",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MoreActionsCancelFurtherResponsesMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreActionsCancelFurtherResponsesMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e5daf1326d8fb6bd99a3c093ab7fafba",
    "id": null,
    "metadata": {},
    "name": "MoreActionsCancelFurtherResponsesMutation",
    "operationKind": "mutation",
    "text": "mutation MoreActionsCancelFurtherResponsesMutation(\n  $id: ID!\n) {\n  cancelFurtherResponses(id: $id) {\n    feedback {\n      id\n      requestCount\n      responseCount\n      requests {\n        id\n        feedbackRecord {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab54ee2128899099b2f9dc9446ae361e";

export default node;
